export const eases = {
    "Power0.easeNone": 'none',
    none: 'none',
    linear: 'none',
    easeIn: 'power1.in',
    easeOut: 'power1.out',
    easeInOut: 'power1.inOut',
    bounceIn: 'bounce.in',
    bounceOut: 'bounce.out',
    bounceInOut: 'bounce.inOut',
    backIn: 'back.in',
    backOut: 'back.out',
    backInOut: 'back.inOut',
    expoIn: 'expo.in',
    expoOut: 'expo.out',
    expoInOut: 'expo.inOut',
    elasticIn: 'elastic.in',
    elasticOut: 'elastic.out',
    elasticInOut: 'elastic.inOut',
    slomo: 'slow(0.7,0.7,false)',
}
